// @flow
import React, {Fragment} from 'react';

import type { HomeCardType } from 'types/Settings';
import { Link } from 'react-router-dom';
import { handleTagEvent }from 'utils/tagManagerUtils';
import BackgroundImage from 'components/fragments/BackgroundImage';

export type StateProps = {
  gerer_club: HomeCardType,
  title: string,
};

const Management = (props: StateProps) => (

  <div className="col col-md-4 col-lg-6 mb-2 mb-md-0">
    { props.gerer_club && props.gerer_club.object_id > 0 && 
    <Fragment>
      <h2 className="mb-3 text-inline">{ props.title || 'À destination des clubs' }</h2>
      <Link
        to={`/${props.gerer_club.object_slug}`}
        className="box card card--hub"
        title={`En savoir plus sur ${props.gerer_club.title}`}
        onClick={handleTagEvent('module hub', `clic gerer mon club`, window.location.pathname)}>
        <BackgroundImage
          className="card__thumbnail img-blue"
          illustration={props.gerer_club.featured_image && props.gerer_club.featured_image.src ? 
            props.gerer_club.featured_image.src : `${process.env.PUBLIC_URL || ''}/img/trash/card.jpg`
          }
          srcset={props.gerer_club.featured_image && props.gerer_club.featured_image.sizes} />
        <div className="card__body">
          <h2 className="card__title">{props.gerer_club.title}</h2>
          <p className="card__desc ft-secondary">
            {props.gerer_club.description}
          </p>
        </div>
        <div className="card__footer">
          <span className="btn btn--cheer">
            <i className="icon icon-chevron-right link-icon is-inline" />
            <span>{props.gerer_club.title}</span>
          </span>
        </div>
      </Link>
    </Fragment>}
  </div>
);

export default Management;
